// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"8d5cce22","359":"1183e02a","529":"4cb407a4"}[chunkId] + ".chunk.js";
};